import(/* webpackMode: "eager" */ "/codebuild/output/src1188431375/src/apps/web/app/[locale]/error.tsx");
